/* eslint-disable react-refresh/only-export-components */
// packages/web/src/pages/Super/components/shared/AddressFieldsGroup.tsx
import { Group, InputBase, Select, TextInput } from '@mantine/core'
import { IMaskInput } from 'react-imask'
import type { UseFormReturnType } from '@mantine/form'
import { states } from '@/utils/states.ts'

export interface AddressFormValues {
  street: string
  city: string
  state: string
  zipCode: string
}

// Validation rules callers plug into useForm({ validate: { address: addressValidation } })
export const addressValidation = {
  state: (value: string) => (!value?.trim() ? 'State is required' : null),
  zipCode: (value: string) => {
    if (!value?.trim()) return 'ZIP code is required'
    const digits = value.replace(/\D/g, '')
    return digits.length === 5 || digits.length === 9 ? null : 'ZIP code must be 5 or 9 digits'
  },
  city: (value: string) => (!value?.trim() ? 'City is required' : null),
  street: (value: string) => (!value?.trim() ? 'Street address is required' : null),
}

/** Normalises a 9-digit ZIP into 5-4 format. Callers can pass the raw form value. */
export function normaliseZip(raw: string): string {
  const digits = raw.replace(/\D/g, '')
  if (digits.length === 9) return `${digits.slice(0, 5)}-${digits.slice(5)}`
  if (digits.length === 5) return digits
  return raw
}

interface AddressFieldsGroupProps {
  // Accept any form whose `address` field has the shape above. Callers pass their own form.
  form: UseFormReturnType<{ address: AddressFormValues } & Record<string, unknown>>
  prefix?: string // path prefix if the address lives at a non-`address` key; default 'address'
}

export function AddressFieldsGroup({ form, prefix = 'address' }: AddressFieldsGroupProps) {
  return (
    <>
      <Group grow>
        <TextInput
          label="Street Address"
          placeholder="Street address"
          {...form.getInputProps(`${prefix}.street`)}
          required
        />
        <TextInput
          label="City"
          placeholder="City"
          {...form.getInputProps(`${prefix}.city`)}
          required
        />
      </Group>
      <Group grow>
        <Select
          label="State"
          placeholder="Select state"
          data={states}
          {...form.getInputProps(`${prefix}.state`)}
          required
          searchable
        />
        <InputBase
          label="ZIP Code"
          placeholder="00000 or 12345-1234"
          component={IMaskInput}
          mask={[{ mask: '00000' }, { mask: '00000-0000' }]}
          {...form.getInputProps(`${prefix}.zipCode`)}
          required
        />
      </Group>
    </>
  )
}
